import React from "react";
import { useNavigate } from "react-router-dom";

const ModernConsulting = () => {
  const navigate = useNavigate();
  const focusAreas = [
    {
      title: "Revenue growth:",
      items: ["Activation,", "Personalization,", "Upsell"],
    },
    {
      title: "Customer interaction:",
      items: ["Agent-assisted journeys,", "AI voice, IVR"],
    },
    {
      title: "Operational efficiency:",
      items: ["Agentic ETL modernization,", "ML deployment"],
    },
  ];

  return (
    <div className="w-full py-12">
      <div className="w-[88%] lg:w-[80%] mx-auto">
        {/* Header Section */}
        <div className="mb-12 lg:mb-16">
          <h2 className="text-[32px] lg:text-[48px] xl:text-[56px] text-white RoobertLight leading-[120%] mb-4">
            OBZ is a modern consulting company built for how enterprises work
            today.
          </h2>
          <h3 className="text-[20px] lg:text-[24px] xl:text-[28px] text-white RoobertMedium leading-[120%] mb-8">
            We help businesses unlock value from data and AI - faster, and with
            greater clarity.
          </h3>
        </div>

        {/* Body Text */}
        <div className="mb-12 lg:mb-16 space-y-6">
          <p className="text-[16px] lg:text-[18px] text-white RoobertRegular leading-[140%]">
            Whether it's boosting activation and cross-sell in banking, driving
            prepaid growth in telecom, or enabling faster campaign cycles in
            retail - we focus on what moves the needle. Not proof-of-concept.
            Not slideware. Actual outcomes.
          </p>
          <p className="text-[16px] lg:text-[18px] text-white RoobertRegular leading-[140%]">
            We deliver with lean, senior teams and a growing library of reusable
            AI components and industry playbooks - working together across
            functions like:
          </p>
        </div>

        {/* Focus Areas Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-12 lg:mb-16">
          {focusAreas.map((area, index) => (
            <div
              key={index}
              className="bg-white p-6 lg:p-8 flex flex-col justify-start relative"
            >
              <h4 className="text-dark-blue RoobertSemiBold text-[18px] lg:text-[20px] leading-[120%] mb-2">
                {area.title}
              </h4>
              <div className="space-y-2">
                {area.items.map((item, itemIndex) => (
                  <p
                    key={itemIndex}
                    className="text-dark-blue RoobertSemiBold text-[16px] lg:text-[18px] leading-[140%]"
                  >
                    {item}
                  </p>
                ))}
              </div>
              <div className="border-r-4 border-t-4 border-fluoro-green absolute top-0 right-0 w-1/4 h-1/2"></div>
            </div>
          ))}
        </div>

        {/* Call-to-Action Button */}
        <div className="text-left">
          <button className="bg-[#66FF00] text-black px-8 py-4 RoobertSemiBold text-[16px] lg:text-[18px] hover:bg-[#5AE600] transition-colors duration-200" onClick={() => navigate('/contact-us')}>
            Schedule a meeting with us
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModernConsulting;
